import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import VoucherRefList from '../../account/voucher/components/VoucherRefList';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLink from '../../../library/form/components/FormLink';

const InvSalesTransaction = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)
        
    return (
        <div className="phSectionActions">
        <div className="uiSingleColumn phViewContent">
            <div className="uiGridCol">
                <ul>
                    <li>
                        <div className="uiResetFloats uiFlexDistributed">
                            <span className="uiLbl">
                                <SarasTrans value="Payments" />
                            </span>
                            <FormButton formObject={formObject} rowKey="" className="uiActionButton uiSpacerL2" text={<SarasTrans value="Payment" />}
                                starIcon={"adds"}
                                action={{ actionId: "edit", paramName: "shVoucherLink", 
                                actionParam: { collectpayment:"1", tdtId:"%dataList.valLDT" }, containerKey: "popup" }}
                            />
                        </div>
                        <div className="uiResetFloats">
                            <div className='uiFlexBox3'>
                                <span className="uiLbl">
                                    <SarasTrans value="Total Paid" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "payment" }} className='uiVal' />
                            </div>
                        </div>
                        <div className="uiResetFloats">
                            <VoucherRefList viewData={formObject.childViews.voucherData} /> 
                        </div>
                    </li>
                    <li>
                        <div className="uiResetFloats uiFlexDistributed">
                            <span className="uiLbl">
                                <SarasTrans value="Last Dispatch" />
                            </span>
                            <FormButton formObject={formObject} rowKey="" className="uiActionButton uiSpacerL2" text={<SarasTrans value="Dispatch" />}
                                starIcon={"adds"}
                                action={{ actionId: "edit", paramName: "shDeliveryInvLink",  
                                        actionParam: { tdtId: "%dataList.valLDT", shOption: "A2", showModeID:'sh' }, containerKey: "popup" }}
                            ></FormButton>
                        </div>
                        <div className="uiFlexBox3">
                            <FormLink formObject={formObject} rowKey="" qvIconKey='print' linkProp={{ target: "_blank" }} className="uiLink uiSpacerH5"
                                action={{ paramName: "lastDeliver", actionId: "show" }}
                            ></FormLink>
                            <FormButton formObject={formObject} rowKey="" className="" text=" "
                                tooltip={<SarasTrans value="Print Last Dispatch" />} 
                                starIcon={'print'}
                                onlyIcon={true}
                                starIconClassName=" uiLink uiIcon"
                                action={{ actionId: "print",  paramName: "lastDeliver", containerKey: "popup",
                                    actionParam: { rptName: "%dataList.rptName", tdtId: "%dataList.valLDT", tdId: "%val" }
                                }}
                            />
                        </div>
                    </li>
                    <li>
                        <div className="uiResetFloats uiFlexDistributed">
                            <span className="uiLbl">
                                <SarasTrans value="Last Invoice" />
                            </span>
                            <div className="uiFlexBox3">
                                <FormButton formObject={formObject} rowKey="" className="uiActionButton" text={<SarasTrans value="Deposit Invoice" />}
                                        size="small"
                                        action={{ actionId: "edit", paramName: "shDepositInvLink",  actionParam: {tdtId: "%dataList.valLDT", shOption: "A1WA", showModeID:'sh' }, 
                                        containerKey: "popup" }}
                                />
                                <FormButton formObject={formObject} rowKey="" className="uiActionButton" text={<SarasTrans value="Full Invoice" />}
                                        action={{ actionId: "edit", paramName: "shItemisedInvLink",  actionParam: {tdtId: "%dataList.valLDT", shOption: "A1", showModeID:'sh' }, 
                                        containerKey: "popup" }}
                                />
                                <FormButton formObject={formObject} rowKey="" className="uiActionButton" text={<SarasTrans value="Currency Invoice" />}
                                        action={{ actionId: "edit", paramName: "shExportInvLink",  actionParam: {tdtId: "%dataList.valLDT", shOption: "A1EX", showModeID:'sh' }, 
                                        containerKey: "popup" }}
                                />
                            </div>
                        </div>
                        <div className="uiFlexBox3">
                            <FormLink formObject={formObject} rowKey="" qvIconKey='print' linkProp={{ target: "_blank" }} className="uiLink uiSpacerH5"
                                action={{ paramName: "taxInv", actionId: "show" }}
                            ></FormLink>
                            <FormButton formObject={formObject} rowKey="" className="" text=" " 
                                tooltip={<SarasTrans value="Print Invoice" />}
                                starIcon={'print'}
                                onlyIcon={true}
                                starIconClassName=" uiLink uiIcon"
                                action={{ actionId: "print",  paramName: "taxInv",
                                    actionParam: { rptName: "%dataList.rptName", tdtId: "%dataList.valLDT", tdId: "#taxInv" }, containerKey: "popup"
                                }}
                            />
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        </div>
    )
}

export default withView(InvSalesTransaction, "invTrans", "invTrans,invTrnHeader")